import { WAVE_EMBED_PROD, WAVE_EMBED_TEST } from '@anm/constants/domains';
import { VideoSizes } from '@anm/hosting-player';

export type PlayButton = {
  color: string;
  enabled: boolean;
};

type ThumbnailProps = {
  hostId: string;
  isProd: boolean;
  button: PlayButton;
  thumbSrc?: string;
} & GetThumbnailSizesProps;

type GetThumbnailSizesProps = {
  sizes: VideoSizes;
  responsive?: boolean;
  imgSizeMultiplier?: number;
};

const getResponsiveThumbSizes = (sizes: VideoSizes): VideoSizes => {
  const ratio = sizes.width / sizes.height;

  switch (true) {
    case ratio > 1:
      return {
        width: 1920,
        height: 1080
      };

    case ratio === 1:
      return {
        width: 1080,
        height: 1080
      };

    case ratio < 1:
      return {
        width: 1080,
        height: 1920
      };

    default:
      return {
        width: 1920,
        height: 1080
      };
  }
};

const getThumbnailSizes = ({ sizes, responsive, imgSizeMultiplier = 2 }: GetThumbnailSizesProps): VideoSizes => {
  const responsiveSizes = responsive ? getResponsiveThumbSizes(sizes) : null;

  const thumbnailWidth = responsiveSizes?.width || sizes.width * imgSizeMultiplier;
  const thumbnailHeight = responsiveSizes?.height || sizes.height * imgSizeMultiplier;

  return {
    width: thumbnailWidth,
    height: thumbnailHeight
  };
};

const getThumbnailSrc = ({ button, isProd, hostId, thumbSrc, ...otherProps }: ThumbnailProps) => {
  if (thumbSrc) return thumbSrc;

  const previewSrc = `${isProd ? WAVE_EMBED_PROD : WAVE_EMBED_TEST}${hostId}/preview.jpg`;

  const thumbSizes = getThumbnailSizes(otherProps);
  const thumbSizesQuery = `?width=${thumbSizes.width}&height=${thumbSizes.height}`;

  const playIconQuery = button.enabled ? `&play=true&color=${encodeURIComponent(button.color)}` : '';

  const thumbnailFullSrc = `${previewSrc}${thumbSizesQuery}${playIconQuery}`;

  return thumbnailFullSrc;
};

export default getThumbnailSrc; // TODO: add test for this helper
